export default "__VITE_ASSET__C$L7j8pa__"